import React, { useEffect, useState } from "react";
import api from "../lib/api";
import AudioPlayer from "./AudioPlayer";

export default function DemosSection() {
  const [demos, setDemos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeId, setActiveId] = useState(null);

  useEffect(() => {
    api.get("/demos")
      .then((r) => setDemos(r.data || []))
      .catch(() => setDemos([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section
      id="demos"
      className="relative py-24 md:py-32 px-6 md:px-12 bg-[#070d1d]"
      data-testid="demos-section"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-14 items-end">
          <div className="md:col-span-7">
            <div className="text-xs tracking-[0.3em] uppercase text-[#F25C32] mb-4">— Demos</div>
            <h2 className="heading-display text-5xl sm:text-6xl md:text-7xl text-[#F5F5F0] leading-[0.95]">
              Escucha la voz<br />
              <span className="text-[#F25C32]">que cuenta historias</span>
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="text-[#9CA3AF] text-base md:text-lg leading-relaxed">
              Una selección de mi trabajo en distintos registros: trailers, comerciales, cine,
              radio y doblaje. Presiona play para escuchar.
            </p>
          </div>
        </div>

        <div className="border-b border-white/10" data-testid="demos-list">
          {loading && (
            <div className="py-12 text-center text-[#9CA3AF] text-sm tracking-[0.2em] uppercase">
              Cargando demos…
            </div>
          )}
          {!loading && demos.length === 0 && (
            <div className="py-12 text-center text-[#9CA3AF] text-sm tracking-[0.2em] uppercase">
              No hay demos disponibles aún.
            </div>
          )}
          {!loading &&
            demos.map((d, i) => (
              <AudioPlayer
                key={d.id}
                demo={d}
                index={i}
                isActive={activeId === d.id}
                onActivate={() => setActiveId(d.id)}
              />
            ))}
        </div>
      </div>
    </section>
  );
}
